import input from '@/components/input'
import { numericInputValidation } from '@/mixins/numericInputValidation'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
  name: 'TextNumbers',
  extends: input,
  mixins: [numericInputValidation],

  data() {
    return {
      inputHasFocus: false,
      inputErrorVisible: false,
      justRendered: true,
      inputValue: ''
    }
  },

  validations: {
    inputValue: {
      required,
      minValue: minValue(1)
    }
  },

  props: {
    icon: {
      type: String,
      required: true
    },
    placeholder: {
      type: String,
      required: false
    },
    type: {
      type: String,
      required: false,
      validator: (v) => ['text', 'password', 'number'].indexOf(v) !== -1
    },
    removeIcon: {
      type: Boolean,
      required: false,
      default: false
    },
    inputError: {
      type: Number
    },
    value: {
      type: [String, Number],
      required: false,
      default: ''
    }
  },

  computed: {
    showRemoveIcon() {
      return this.removeIcon && this.inputValue && this.inputValue.length > 0
    },

    isInputOnError() {
      return this.$v.inputValue.$invalid && !this.justRendered
    }
  },

  methods: {
    checkValue() {
      if (this.shouldValidateNumericField(this.name)) {
        this.inputValue = (this.value === 0 || this.value === '0') ? '' : this.value
      } else {
        this.inputValue = this.value == 0 ? '' : this.value
      }
    },

    handleInputChange(event) {
      const eventType = event.type
      let value = event.target.value
      
      if (this.shouldValidateNumericField(this.name)) {
        value = this.sanitizeNumericValue(value)
        event.target.value = value
      } else {
        value = value.replace(/[^0-9]/g, '')
        
        if (value === '0' || Number(value) <= 0) {
          value = ''
        }
        
        event.target.value = value
      }
      
      this.inputValue = value
      this.$v.$touch()
      this.$emit(eventType, this.inputValue)
    },

    handleKeydown(event) {
      if (this.shouldValidateNumericField(this.name)) {
        this.preventInvalidNumericKeys(event)
      } else {
        const invalidChars = ['-', '+', 'e', 'E', '.', ',']
        if (invalidChars.includes(event.key)) {
          event.preventDefault()
        }
      }
    }
  },

  watch: {
    value: {
      immediate: true,
      handler(newVal) {
        if (this.shouldValidateNumericField(this.name)) {
          this.inputValue = (newVal === 0 || newVal === '0') ? '' : newVal
        } else {
          this.inputValue = newVal == 0 ? '' : newVal
        }
      }
    }
  },

  mounted() {
    this.checkValue()
  }
}